import React from 'react';
import PropTypes from 'prop-types';

import Slot from '../Slot';
import { Layout } from '../styles';

const SpaceDetails = ({ slot }) => {
	const { type, data, layout } = slot[0];

	return (
		<Layout>
			<Slot
				top={5}
				left={5}
				width={30}
				height={42.5}
				component={type}
				data={data}
				layout={layout}
			/>
			<Slot
				top={52.5}
				left={5}
				width={30}
				height={42.5}
				component={type}
				data={data}
				layout={layout}
			/>
			<Slot
				top={5}
				left={40}
				width={55}
				height={90}
				component={type}
				data={data}
				layout={layout}
			/>
		</Layout>
	)
}

SpaceDetails.defaultProps = {
	slot: []
}

SpaceDetails.propTypes = {
	slot: PropTypes.array,
}

export default SpaceDetails
